import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/main.css';
import App from './App';
// import * as serviceWorker from './pwa';
import reportWebVitals from './reportWebVitals';
require('dotenv').config();


if (process.env.NODE_ENV !== "development") console.log = () => {};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.pwa();
